import { ContractRenewalDTO } from "./ContractRenewalDTO";

export class ContractDTO {
    public number: string;
    public description: string;
    public contractDate?: Date;
    public renewal: ContractRenewalDTO;
    public historicRenewals: ContractRenewalDTO[];
    public delinquent: boolean;

    constructor(obj?) {
        obj = obj || {};
        this.number = obj.number || "";
        this.description = obj.description || "";
        this.contractDate = obj.contractDate || null;
        this.renewal = new ContractRenewalDTO(obj.renewal);
        this.historicRenewals = obj.historicRenewals || [];
        this.delinquent = obj.delinquent || false;
    }
}
